export const CATEGORY_LIST = ["PLAN", "TOPUP"];
export const TAG_LIST = [
  { id: 1, label: "Most Popular", value: "Most Popular" },
  { id: 2, label: "None", value: "" },
];

export const orderStatusOptions = [
  "PENDING",
  "COMPLETED",
  "CANCELLED",
  "FAILED",
];
export const paymentStatusOptions = [
  "PENDING",
  "SUCCESS",
  "FAILED",
  "REFUNDED",
];

export const operatorOptions = ["PENDING", "COMPLETED", "CANCELLED"];

//dashboard
export const TIMEPERIOD_SALES = ["Daily", "Weekly", "Monthly", "Yearly"];
export const TIMEPERIOD_ONBOARD_DEVICE = [
  "Daily",
  "Weekly",
  "Monthly",
  "Yearly",
];
export const TIMEPERIOD_TOPSELLING = ["Daily", "Weekly", "Monthly", "Yearly"];

//simswap
export const SIMSWAP_STATUSES = ["OPEN", "IN_REVIEW", "REJECTED", "APPROVED"];
